import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { setRejectServicePopup, rejectService, getTaskList } from "../../store/api/Services";
import Loader from 'react-loader-spinner';
const ModalRejectService = (props) => {
    const openRejectServicePopup = useSelector(state => state.popup.openRejectServicePopup);
    const dispatch = useDispatch();
    const {serviceID, serviceType, show} = openRejectServicePopup;
    const rejectSrv = () => {
        let rejectDesc = document.getElementById("RejectDesc").value;
        dispatch(rejectService(serviceType, serviceID, rejectDesc, ()=>{dispatch(getTaskList(0,20)); dispatch(setRejectServicePopup({show:false}))}));
    }
    return (
        <Modal show={show === true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#e40375' }}>رد سرویس</Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="form-group">
                        <label>دلیل رد</label>
                        <input type="text" id="RejectDesc" att='' className="form-control" />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: "flex-start" }}>
            <Button className="btn-success" style={{ fontSize: "12px" }} onClick={rejectSrv}>رد سرویس</Button>                
                <Button className="btn-danger" style={{ fontSize: "12px" }} onClick={() => dispatch(setRejectServicePopup({show:false}))}>بستن</Button>
            </Modal.Footer>
        </Modal>
    )
}
export default ModalRejectService;